import { send } from '../../../../src/network/network';

export type PreferenceOptionKey =
  | 'preference_options.food_format'
  | 'preference_options.food_quality'
  | 'preference_options.food_format.v2'
  | 'preference_options.food_format.v3';

export interface PreferenceOption {
  tag_id: number;
  name: string;
  description: string | null;
  image_url: string | null;
  thumbnail_url: string | null;
  associated_tag_ids: number[];
}

export interface GetPreferenceOptionsResponse {
  pages: [
    {
      key: PreferenceOptionKey;
      options: PreferenceOption[];
    },
  ];
}

export async function getPreferenceOptions() {
  return await send<GetPreferenceOptionsResponse>({
    path: '/api/v2/preference_options/',
    method: 'GET',
  });
}
